export default __webpack_public_path__ + "static/adelie-warehouse-38892a8d1eeee4d9788c128f7231d3e9.jpg";